// dependencies
import React, { useCallback, useEffect, useRef } from "react";
import { Map, Marker, TileLayer } from "react-leaflet";
import L from "leaflet";

import "leaflet/dist/leaflet.css";

const classicMarkerIcon = new L.Icon({
  iconUrl: "/images/marker.png",
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
  iconSize: [32, 32],
});

type PropsType = {
  lat: number;
  lng: number;
  dragging?: boolean;
} & React.ComponentProps<any>;

const RoomMap: React.FunctionComponent<PropsType> = (props) => {
  const { lat, lng, dragging = true, ...otherProps } = props;

  const $map = useRef<any>();

  const updateViewport = useCallback(() => {
    if ($map.current) {
      const bounds = new L.LatLngBounds([[lat, lng]]);

      const map = $map.current.leafletElement;
      map.fitBounds(bounds, {
        padding: [15, 15],
        maxZoom: 12,
      });
    }
  }, [lat, lng]);

  useEffect(() => {
    updateViewport();
  }, [updateViewport]);

  return (
    <Map ref={$map} style={{ height: 300 }} dragging={dragging} {...otherProps}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      />

      <Marker position={[lat, lng]} icon={classicMarkerIcon} />
    </Map>
  );
};

export default RoomMap;
